/**
 * .default-timezone
 * Bind any data-timezone element to timezone ID
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 */

$(function()
{
    "use strict";

    /**
     * Match the TZ to the Browser settings
     *
     * @return  Void
     */
    var setTimezoneValue = function(){

        // Get the offset
        var $offset = moment().utcOffset();

        // Set DST
        var $dst =  moment().isDST() ? 0 : 60;

        // Pick the timezone
        var $timezone = 1;

        switch(($offset + $dst) * -1){
            case 300:
                $timezone = 3;
                break;
            case 360:
                $timezone = 4;
                break;
            case 420:
                $timezone = 5;
                break;
            case 480:
                $timezone = 6;
                break;
            case 540:
                $timezone = 7;
                break;
        }

        // If any input.timezone if empty, set it to the current offset
        if ($('.timezone').val() == ''){
            $('.timezone').val($timezone);
        }
    }

    // Register the function
    $(document).ready( setTimezoneValue );
});
